// 给测试与运营用来快速测试验证问题的文件
const TestModal = {
  showtimeslimit: localStorage.getItem("showtimeslimit"),
  completeInfoVisible: localStorage.getItem("completeInfoVisible"),
  isPremium: localStorage.getItem("isPremium"),
  hasSecond: localStorage.getItem("hasSecond"),
  isGray: localStorage.getItem("isGray"),
};

export default TestModal;
